// @ts-nocheck
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events#select_promotion
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackSelectPromotionItem extends Toolkit.GoogleAnalytics.AnyPromotionItem {}

export interface TrackSelectPromotionParameters
    extends TrackEventBaseParameters<
        "creative_name" | "creative_slot" | "promotion_id" | "promotion_name",
        null,
        TrackSelectPromotionItem
    > {}

const trackSelectPromotion = (
    parameters: TrackSelectPromotionParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "select_promotion", ...parameters }, options);
};

export default trackSelectPromotion;
